import React, { useState, useEffect } from "react";
import FileBase64 from "../../components/Upload/UploadFile";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import { Card, Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import {
    TextField,
    Typography,
    Grid,
    Button,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import PublishIcon from "@mui/icons-material/Publish";
import { FileExcelFilled, FilePdfFilled } from "@ant-design/icons";
import { dealerAgentSampleDownloadFile } from '../../redux/actions/dealerAgentDownloadSampleFileAction';
import { dealerUploadAgentFile } from "../../redux/actions/dealerUploadAgentFileAction"
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const DealerAgentUpload = () => {
    const classes = useStyles();
    const [uploadFile, setUploadFile] = useState("");
    const dispatch = useDispatch();
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const [openUploadModal, setOpenUploadModal] = React.useState(false);

    const [uploadSampleFileStatus, setUploadSampleFileStatus] = useState(false);
    const [uploadSampleFileArray, setUploadSampleFileArray] = useState([]);
    const [
        downloadDealerSampleFileStatus,
        setDownloadDealerSampleFileStatus
    ] = useState(false);



    const agentDownloadSampleFileRes = useSelector(
        ({ dealerAgentDownloadSampleFiles }) => dealerAgentDownloadSampleFiles
    );

    const agentUploadFileRes = useSelector(
        ({ dealerUploadAgentFiles }) => dealerUploadAgentFiles
    )
    const handleChange = ({ target: { name, value } }) => {
        if (name === "uploadFile") {
            setUploadFile(value);
        }
    };
    const [UploadFileName, setUploadFileName] = useState("");
    const handleNoticationClose = () => {

        setOpenUploadModal(false)
    };
    const handleAttachmentsDoc = (e, uploadFile) => {
        if (uploadFile == "uploadFile") {
            setUploadFile(e.base64);
            setUploadFileName(e.name);
            setBtnDisable(false);
        }
    };

    const DownloadAgentSampleFileReq = () => {
        setDownloadDealerSampleFileStatus(true)
        const req = {
            actionCustomerMasterRequestVO: {

                dealerId: regenerateTokenRes.data.partnerId
            }
        }
        dispatch(dealerAgentSampleDownloadFile(req, authToken));

    }
    useEffect(() => {
        if (downloadDealerSampleFileStatus) {
            if (agentDownloadSampleFileRes.data.status == "success") {
                var link = document.createElement("a");
                link.download = agentDownloadSampleFileRes.data.fileName;
                link.href =
                    "data:application/octet-stream;base64," +
                    agentDownloadSampleFileRes.data.fileDate.split(`,`)[1];
                link.click();
            }
            // if (downloadSampleFileOfCurrencyRateRes.data.status == "Failed") {

            // }
        }
    }, [agentDownloadSampleFileRes.data.status]);
    const uploadAgentFileReq = () => {
        setUploadSampleFileStatus(true);
        const fd = new FormData();
        const Req = {

            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                file: uploadFile.split(",")[1]
            }
        };

        dispatch(
            dealerUploadAgentFile(
                Req,
                authToken
            )
        );
    };
    // useEffect(() => {
    //     if (uploadSampleFileStatus) {
    //         if (agentUploadFileRes.data.status == "success") {
    //             swalWithBootstrapButtons.fire({
    //                 type: "success",
    //                 title: "Upload File Successfully"
    //             });
    //         }
    //         if (agentUploadFileRes.data.status == "failed") {
    //             swalWithBootstrapButtons.fire({
    //                 type: "error",
    //                 title: " File  is Not Upload"
    //             });
    //             if (
    //                 agentUploadFileRes.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 agentUploadFileRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //         }
    //         if (agentUploadFileRes.data.status == "Failed") {
    //             swalWithBootstrapButtons.fire({
    //                 type: "error",
    //                 title: " File  is Not Upload"
    //             });
    //             if (
    //                 agentUploadFileRes.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 agentUploadFileRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //         }
    //     }
    // }, [agentUploadFileRes.data.status]);

    const UploadFileFunc = () => {
        if (uploadSampleFileStatus) {
            if (agentUploadFileRes.data.status == "success") {
                setUploadSampleFileArray(agentUploadFileRes.data);
                setOpenUploadModal(true)
            }
            if (agentUploadFileRes.data.status == "failed") {
                setUploadSampleFileArray(agentUploadFileRes.data);
                setOpenUploadModal(true)
            }

        }
    }
    useEffect(() => {
        UploadFileFunc();
    }, [agentUploadFileRes.data.status]);


    const [btnDisable, setBtnDisable] = useState(true);
    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem", textAlign: "center" }}
                    >
                        <Grid
                            className="d-flex align-items-center justify-content-center"
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            lg={4}
                        >
                            <p style={{ fontSize: "18px", margin: "0" }}>Select Rate File </p>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            {/* <input
                name="uploadFile"
                value={uploadFile}
                className="my-2"
                type="file"
                placeholder="Browse"
                onChange={handleChange}
              /> */}

                            <FileBase64
                                multiple={false}
                                name={false}
                                id="documentGuard"
                                accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
                                onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
                                showUploadList={false}
                                value={UploadFileName}
                            />
                            {UploadFileName ? UploadFileName : ""}

                            {/* <Button
                style={{
                  marginLeft: "0.2rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
              >
                Browse
              </Button> */}
                        </Grid>
                        <Grid item sm={12} md={4} lg={4}>
                            <Button
                                style={{
                                    marginLeft: "0.2rem",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                className="riskRuleButton"

                                onClick={DownloadAgentSampleFileReq}
                                endIcon={
                                    <FileExcelFilled
                                        style={{ color: "#fff", fontSize: "16px" }}
                                    />
                                }
                            >
                                Sample Limit File:
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        style={{
                            padding: "25px",
                            marginTop: "1.5rem",
                            marginBottom: "15px"
                        }}
                    >
                        <Grid item md={4} className="text-center">
                            {btnDisable ? (
                                <Button
                                    style={{
                                        backgroundColor: "#80dcfa",
                                        color: "white"
                                    }}
                                    variant="contained"
                                    className="riskRuleButton"
                                    onClick={uploadAgentFileReq}
                                    endIcon={<PublishIcon />}
                                    disabled={btnDisable}
                                >
                                    Upload
                                </Button>
                            ) : (
                                <Button
                                    style={{
                                        backgroundColor: "#00b9f5",
                                        color: "white"
                                    }}
                                    variant="contained"
                                    className="riskRuleButton"
                                    onClick={uploadAgentFileReq}
                                    endIcon={<PublishIcon />}
                                    disabled={btnDisable}
                                >
                                    Upload
                                </Button>
                            )}

                            {/* <Button  
                style={{
                  backgroundColor: "#00b9f5", 
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={uploadSampleFileOfCurrencyRates}
                endIcon={<PublishIcon />}
                disabled={btnDisable}
              // disabled="true"
              >
                Upload
              </Button> */}
                        </Grid>
                    </Grid>
                </Card>

            </Layout>

            {uploadSampleFileArray.status == "success" && (
                <div>
                    <Dialog open={openUploadModal} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {uploadSampleFileArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {uploadSampleFileArray.status == "failed" && (
                <div>
                    <Dialog open={openUploadModal} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {uploadSampleFileArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default DealerAgentUpload

